import type { JSX, ReactNode } from 'react';
import { Link } from 'react-router';
import { useI18n } from '../i18n/context.js';
import { BrandLogo } from './BrandLogo.js';
import { LegalLinks } from './LegalLinks.js';

/** Общая рамка экранов входа: заголовок, подзаголовок, карточка с формой. */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}): JSX.Element {
  const { t } = useI18n();
  return (
    <main className="mx-auto flex min-h-screen w-full max-w-md flex-col justify-center gap-6 px-4 py-10">
      <header className="text-center">
        <Link to="/" aria-label={t.app.name} className="inline-flex no-underline">
          <BrandLogo size="md" />
        </Link>
        <h1 className="mt-3 text-2xl font-semibold">{title}</h1>
        {subtitle ? (
          <p className="mt-2 text-sm text-[var(--kitup-color-muted)]">{subtitle}</p>
        ) : null}
      </header>

      <div className="rounded-[var(--kitup-radius-md)] bg-white/70 p-6 shadow-sm">{children}</div>

      <footer className="grid gap-3 text-center text-sm text-[var(--kitup-color-muted)]">
        {/* Links read as links: the sign-up/sign-in switch was grey text like the words around it. */}
        {footer ? (
          <div className="[&_a]:font-medium [&_a]:text-[var(--kitup-color-accent)] [&_a]:underline [&_a]:underline-offset-2">
            {footer}
          </div>
        ) : null}
        <LegalLinks compact />
      </footer>
    </main>
  );
}
